module.exports = __webpack_public_path__ + "images/cc38891e8d2fe4139ffe649e745cb72b-OSC_HorizontalLogo_Black300.jpg";